var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { DiagramConsts } from '../diagram-consts';
import { IndicatorLightType } from '../utils/indicator-light/indicator-light-type';
import { ConditionalEnableNodeElement } from './base/conditional-enable-node-element';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
import { GraphService } from '../../../../shared/gallery/graph.service';
import { TextAlignHelper } from '../../shared/helpers/text-align-helper';
var SwitchIndicatorLightElement = /** @class */ (function (_super) {
    __extends(SwitchIndicatorLightElement, _super);
    function SwitchIndicatorLightElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    SwitchIndicatorLightElement.prototype.compile = function (model, data, svg) {
        model['version'] = 5;
        model['angle'] = data.angle;
        model['size'] = this.sizeService.parse(data.size);
        model['useSwitch'] = data.useSwitch && null != data.switchSettings && null != data.switchSettings.settings
            && null != data.switchSettings.settings.variableName && data.switchSettings.settings.variableName.length > 0;
        if (model['useSwitch']) {
            var variableName_1 = data.switchSettings.settings.variableName;
            if (data.switchSettings.settings.variableVersion) {
                var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === variableName_1; });
                if (null != variable) {
                    data.switchSettings.settings.dataType = variable.dataType;
                    data.switchSettings.settings.minValue = variable.minValue;
                    data.switchSettings.settings.maxValue = variable.maxValue;
                    if (variable.readWriteModel === 2) {
                        data.switchSettings.settings.isWriteOnly = true;
                    }
                }
                else {
                    data.switchSettings.settings.variableName = undefined;
                }
            }
            else {
                var variableGroupName_1 = data.switchSettings.settings.variableGroupName;
                var dataSourceCode_1 = data.switchSettings.settings.dataSourceCode;
                var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.dataSourceCode === dataSourceCode_1
                    && v.fBoxVariableName === variableName_1 && (!variableGroupName_1 || (v.fBoxGroupName === variableGroupName_1)); });
                if (null != variable) {
                    data.switchSettings.settings.variableGroupName = variable.fBoxGroupName;
                    data.switchSettings.settings.dataType = variable.dataType;
                    data.switchSettings.settings.minValue = variable.minValue;
                    data.switchSettings.settings.maxValue = variable.maxValue;
                    if (variable.readWriteModel === 2) {
                        data.switchSettings.settings.isWriteOnly = true;
                    }
                }
            }
            model['switchSettings'] = data.switchSettings;
        }
        model['useIndicatorLight'] = data.useIndicatorLight && null != data.indicatorLightSettings
            && null != data.indicatorLightSettings.settings && null != data.indicatorLightSettings.settings.variableName
            && data.indicatorLightSettings.settings.variableName.length > 0;
        if (model['useIndicatorLight']) {
            var variableName_2 = data.indicatorLightSettings.settings.variableName;
            if (data.indicatorLightSettings.settings.variableVersion) {
                var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === variableName_2; });
                if (null != variable) {
                    data.indicatorLightSettings.settings.dataType = variable.dataType;
                }
            }
            else {
                var variableGroupName_2 = data.indicatorLightSettings.settings.variableGroupName;
                var dataSourceCode_2 = data.indicatorLightSettings.settings.dataSourceCode;
                var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.dataSourceCode === dataSourceCode_2
                    && v.fBoxVariableName === variableName_2 && (!variableGroupName_2 || (v.fBoxGroupName === variableGroupName_2)); });
                if (null != variable) {
                    data.indicatorLightSettings.settings.variableGroupName = variable.fBoxGroupName;
                    data.indicatorLightSettings.settings.dataType = variable.dataType;
                }
            }
            model['indicatorLightSettings'] = data.indicatorLightSettings;
        }
        var states = _.cloneDeep(data.states);
        _.forEach(states, function (state) {
            if (data.useIndicatorLight && data.indicatorLightSettings && IndicatorLightType.Bit === data.indicatorLightSettings.type) {
                state.condition.logic = state.condition.operator;
                delete state.condition['operator'];
            }
            state.text.font.isBold = FontStyleHelper.isBold(state.text.font.fontStyle);
            state.text.font.isItalic = FontStyleHelper.isItalic(state.text.font.fontStyle);
            state.text.font.fontFamily = FontStyleHelper.fontFamily(state.text.font.fontStyle);
            state.text.font.fontSize = state.text.font.fontSize.slice(0, -2);
            delete state.text.font['fontStyle'];
        });
        model['states'] = states;
        model['useGraph'] = data.useGraph;
        model['graphSetting'] = data.graphSetting;
        model['useSecurity'] = data.useSecurity;
        model['isRecordOperation'] = data.isRecordOperation;
        if (data.isRecordOperation) {
            model['operationDescription'] = data.operationDescription;
        }
        model['enablePassword'] = data.enablePassword;
        model['dynamicSetting'] = data.dynamicSetting;
        model['location'] = go.Point.parse(data.loc);
        model['fixedPositionType'] = data.fixedPositionType;
        svg.children().remove();
    };
    SwitchIndicatorLightElement.prototype.getPaletteTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10 }, new go.Binding('source', 'useSwitch', function (useSwitch, __) { return useSwitch ?
            '/assets/common/images/configure/elements/switch.png' :
            '/assets/common/images/configure/elements/indicator-light.png'; })), $(go.TextBlock, { alignment: go.Spot.Center, editable: false }, new go.Binding('text', 'useSwitch', function (useSwitch, __) { return useSwitch ? _this.l('Switch') : _this.l('IndicatorLight'); })));
    };
    SwitchIndicatorLightElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Auto', {
            rotatable: true,
            resizable: true, resizeObjectName: 'SHAPE',
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, 'Rectangle', {
            name: 'SHAPE',
            spot1: go.Spot.TopLeft,
            spot2: go.Spot.BottomRight,
            fill: 'transparent',
            stroke: 'transparent',
            strokeWidth: 0.5,
            strokeDashArray: [4, 4]
        }, new go.Binding('stroke', 'useGraph', function (useGraph) { return useGraph ? 'transparent' : 'gray'; }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify)), $(go.Picture, { name: 'IMAGE' }, { sourceCrossOrigin: function (__) { return 'anonymous'; } }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('source', 'graphSetting', function (setting, __) { return _this.graphService.getCustomStyleGraphUrl(setting); }), new go.Binding('visible', 'useGraph')), $(go.TextBlock, { editable: false, alignment: go.Spot.Center, verticalAlignment: go.Spot.Center }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('font', '', function (data) { return _this.setEditTextFontFamilyMustBeYaHei(data.states[0].text.font.fontStyle); }), new go.Binding('isUnderline', 'states', function (states) { return states[0].text.font.isUnderline; }), new go.Binding('stroke', 'states', function (states) { return states[0].text.font.color; }), new go.Binding('text', 'states', function (states) { return states[0].text.content; }), new go.Binding('textAlign', 'states', function (states) { return states[0].text.font.textAlign ? states[0].text.font.textAlign : TextAlignHelper.AlignCenter; })));
    };
    SwitchIndicatorLightElement.prototype.setEditTextFontFamilyMustBeYaHei = function (font) {
        var fontArray = font.split('px');
        fontArray.pop();
        fontArray.push(' Microsoft YaHei,msyh');
        return fontArray.join('px');
    };
    SwitchIndicatorLightElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.switchIndicatorLightKey;
    };
    return SwitchIndicatorLightElement;
}(ConditionalEnableNodeElement));
export { SwitchIndicatorLightElement };
